module.exports = __webpack_public_path__ + "static/media/InsuranceValidator.aceb5c8a.png";